import React from 'react';
import { Flex, Text } from '@chakra-ui/react';

/**
 * Placeholder shown for pipelines that are not implemented yet.
 *
 * Routes for these pipelines are intercepted by PipelineGate in App.tsx, which
 * shows a "Coming Soon" notice and redirects to the dashboard - so this renders
 * only if a route is opened without that gate.
 */
const ComingSoon: React.FC<{ title?: string }> = ({ title }) => (
  <Flex direction="column" align="center" justify="center" minH="60vh" px={6} textAlign="center">
    {title && (
      <Text fontSize="sm" fontWeight={600} color="#8c89b1" letterSpacing="wide" mb={2}>
        {title.toUpperCase()}
      </Text>
    )}
    <Text fontSize="2xl" fontWeight={700} color="#1a1262" mb={3}>
      Coming Soon
    </Text>
    <Text fontSize="md" color="#8c89b1" maxW="440px" lineHeight={1.5}>
      This pipeline is not available yet. Please contact us if you need access.
    </Text>
  </Flex>
);

export default ComingSoon;
